export default __webpack_public_path__ + "static/media/bank.8dd78250.svg";